import React, { useEffect, useState } from 'react';

export const MobileWorkspaceBrand = ({ workspace }) => {
  const logo = workspace?.company_logo_url;
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [logo]);
  const logoUrl = logo && (/^https?:\/\//i.test(logo) ? logo : `${process.env.REACT_APP_BACKEND_URL}${logo}`);
  const name = workspace?.company || 'Your Workspace';

  return (
    <div className="mobile-workspace-brand" data-testid="mobile-workspace-brand">
      {logoUrl && !failed ? (
        <img src={logoUrl} alt={name} onError={() => setFailed(true)} data-testid="mobile-workspace-logo" />
      ) : (
        <div className="font-manrope" data-testid="mobile-workspace-wordmark">Projek<span className="brand-dot">.</span></div>
      )}
      <div className="mobile-workspace-name" title={name} data-testid="mobile-workspace-name">{name}</div>
    </div>
  );
};